export const blogKeys = {
  blog: ['blog'] as const,
  getArticles: (params: BlogQueryParams) => [
    ...blogKeys.blog,
    'getArticles',
    params
  ],
  getCategories: () => [...blogKeys.blog, 'getCategories'],
  getTags: () => [...blogKeys.blog, 'getTags'],
  getArticleBySlug: (slug: string) => [
    ...blogKeys.blog,
    'getArticleBySlug',
    slug
  ]
}
